var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require('@/assets/logoReport.png'),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }